import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Analysis from './pages/Analysis';
import Analytics from './pages/Analytics';
import Prediction from './pages/Prediction';
import History from './pages/History';
import Insights from './pages/Insights';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar />
        <Routes>
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/prediction" element={<Prediction />} />
          <Route path="/history" element={<History />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/" element={<Navigate to="/prediction" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
